import React from 'react';
import { useTranslation } from 'react-i18next';

import { Root, Knob } from './Toggle.styles';

export type ToggleProps = {
  on: boolean;
  /** i18n key for the accessible label (attribute copy → t()). */
  label: string;
  /** Interpolation values for `label`, e.g. { name: 'Halloween' } for "Toggle {{name}}". */
  labelValues?: Record<string, string | number>;
  /** Identifier surfaced via `event.currentTarget.dataset.id`. */
  id?: string;
  /** Non-interactive (e.g. a required, always-on preference). */
  disabled?: boolean;
  onToggle: (event: React.MouseEvent<HTMLElement>) => void;
};

/** Accessible on/off switch. Reads its id from `dataset.id` on toggle. */
export const Toggle = ({ on, label, labelValues, id, disabled = false, onToggle }: ToggleProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Root
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={t(label, labelValues)}
      $on={on}
      data-id={id}
      disabled={disabled}
      onClick={onToggle}
    >
      <Knob $on={on} />
    </Root>
  );
};

export default Toggle;
